import { ImageWrapper } from "@/lib/styles";
import { pageMargins } from "@/lib/styles/helpers";
import styled from "styled-components";

export const Container = styled(ImageWrapper)`
  ${pageMargins};

  padding-bottom: calc(100% * 9 / 16);
`;
